/**
 * What the site is doing right now, for a visitor with no session.
 *
 * Asked once on first load, before anything else can be asked: the app
 * cannot find out whether to show the pre-launch page from behind a login
 * that may not even be open.
 */
export interface ISiteMode {
  /** True while strangers get the pre-launch page instead of the app. */
  landingModeEnabled: boolean;
  /**
   * False while nobody new can create an account. Hiding the form is a
   * courtesy, not the gate -- the server refuses the registration either
   * way (see the backend's AuthController.Register).
   */
  registrationEnabled: boolean;
}

/** Someone leaving their details on the pre-launch page. */
export interface ICreateSignupLeadRequest {
  email: string;
  phone?: string;
  message?: string;
  /** SignupLeadInterests values -- at least one. */
  interests: string[];
  consentGiven: boolean;
  /** The exact sentence shown on screen, sent back so what is stored is what was read. */
  consentText: string;
  /** Honeypot: hidden from humans, so anything in it came from a bot. Always sent empty. */
  website?: string;
}

/** Waiting-list entry, as the admin screen reads it. */
export interface ISignupLead {
  id: number;
  email: string;
  phone?: string;
  message?: string;
  interests: string[];
  contacted: boolean;
  contactedAt?: string;
  consentedAt: string;
  createdAt: string;
}

/**
 * What somebody says they are here for. Multiple, because the two sides of
 * this marketplace overlap in real life: an operator with his own machine
 * both owns machinery and sells a service.
 */
export const SIGNUP_LEAD_INTERESTS = ['HasMachinery', 'WantsMachinery', 'OffersServices', 'WantsServices'] as const;
